<!-- 由 suu 创建于 2022-01-06 星期四 -->
<!-- 顶部搜索 -->
<template>
  <div class="TheHeader">
    <van-search
      v-model="searchValue"
      input-align="center"
      placeholder="搜索班级"
      @search="onSearch"
      @cancel="onCancel"
    />
    <div class="th-se">
      <van-dropdown-menu active-color="#f04646">
        <van-dropdown-item
          v-model="status"
          @change="handelOpChange"
          :options="optionStatus"
        />
        <van-dropdown-item
          @open="handeloOpen('que')"
          @change="handelOpChange"
          v-model="fid"
          :options="optionFid"
        />
        <van-dropdown-item
          @open="handeloOpen('pro')"
          @change="handelOpChange"
          v-model="pid"
          :options="optionPid"
        />
        <van-dropdown-item
          @open="handeloOpen('coach')"
          @change="handelOpChange"
          v-model="cid"
          :title="cTitle"
          :options="optionCid"
        />
        <van-dropdown-item
          @open="handeloOpen('order')"
          @change="handelOpChange"
          :title="orderTitle"
          ref="item"
        >
          <div class="se-op" v-for="(item, index) in optionOrder" :key="index">
            <div class="op-title">{{ item.title }}</div>
            <div
              @click="handelClickOpItem(item, o, index)"
              class="op-item"
              :class="{
                'op-item-ac': order == item.key && order_type == o.value
              }"
              v-for="(o, oi) in item.options"
              :key="oi"
            >
              {{ o.text }}
            </div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
      <div class="se-right">
        <span :class="{ 'r-icon-ac': order != '' && order_type == 'asc' }"
          >↿</span
        ><span :class="{ 'r-icon-ac': order != '' && order_type == 'desc' }"
          >⇂</span
        >
      </div>
    </div>
    <!-- <div class="th-reset" @click="handelReset">清空筛选</div> -->
  </div>
</template>

<script>
export default {
  name: 'TheHeader',

  components: {},

  props: {},

  data() {
    return {
      searchValue: '',
      status: 0,
      fid: '',
      pid: '',
      cid: '',
      order: '',
      order_type: '',
      optionStatus: [
        { text: '状态', value: 0 },
        { text: '未开始', value: 1 },
        { text: '进行中', value: 2 },
        { text: '已结束', value: 3 }
      ],
      optionFid: [{ text: '营期', value: '' }],
      optionPid: [{ text: '班级', value: '' }],
      optionCid: [{ text: '营养师', value: '' }],
      optionOrder: [
        {
          title: '智能排序',
          key: '',
          options: [
            {
              text: '默认排序',
              value: ''
            }
          ]
        }
      ]
    }
  },

  computed: {
    // 营养师标题 过滤
    cTitle() {
      return this.optionCid
        .find((v) => v.value == this.cid)
        .text.replace('营养师', '')
    },
    // 排序当前标题
    orderTitle() {
      console.log('====================================')
      console.log('this.optionOrder', this.optionOrder, this.order)
      console.log('====================================')
      const op = this.optionOrder.find((o) => {
        return o.key === this.order
      })
      return op.title
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 清空选项
    handelReset() {
      this.status = 0
      this.fid = ''
      this.pid = ''
      this.cid = ''
      this.order = ''
      this.order_type = ''
      this.handelOpChange()
    },
    // 选项改变
    handelOpChange(from) {
      // 筛选 清空 搜索
      if (from != 'search') {
        this.searchValue = ''
        this.$emit('on-search', this.searchValue)
      }
      const { status, fid, pid, cid, order, order_type } = this.$data
      this.$emit('on-change', {
        status,
        fid,
        pid,
        cid,
        order,
        order_type
      })
    },
    // 调起各选项
    handeloOpen(type) {
      switch (type) {
        case 'que':
          if (this.optionFid.length <= 1) {
            this.$toast.loading('加载选项中··')
            this.$http
              .getApp('/member/AppCampCoach/getFilterItem', {
                type
              })
              .then((res) => {
                this.$toast.clear()
                if (res.data.code == 200) {
                  this.optionFid = this.optionFid.concat(res.data.data)
                } else {
                  this.$dialog.alert({ message: res.data.msg })
                }
              })
          }
          break
        case 'pro':
          if (this.optionPid.length <= 1) {
            this.$toast.loading('加载选项中··')
            this.$http
              .getApp('/member/AppCampCoach/getFilterItem', {
                type
              })
              .then((res) => {
                this.$toast.clear()
                if (res.data.code == 200) {
                  this.optionPid = this.optionPid.concat(res.data.data)
                } else {
                  this.$dialog.alert({ message: res.data.msg })
                }
              })
          }
          break
        case 'coach':
          if (this.optionCid.length <= 1) {
            this.$toast.loading('加载选项中··')
            this.$http
              .getApp('/member/AppCampCoach/getFilterItem', {
                type
              })
              .then((res) => {
                this.$toast.clear()
                if (res.data.code == 200) {
                  this.optionCid = this.optionCid.concat(res.data.data)
                } else {
                  this.$dialog.alert({ message: res.data.msg })
                }
              })
          }
          break
        case 'order':
          if (this.optionOrder.length <= 1) {
            this.$toast.loading('加载选项中··')
            this.$http
              .getApp('/member/AppCampCoach/getFilterItem', {
                type
              })
              .then((res) => {
                this.$toast.clear()
                if (res.data.code == 200) {
                  this.optionOrder = res.data.data
                } else {
                  this.$dialog.alert({ message: res.data.msg })
                }
              })
          }
          break

        default:
          break
      }
    },
    // 搜索
    onSearch() {
      // 搜索 清空 筛选
      this.status = 0
      this.fid = ''
      this.pid = ''
      this.cid = ''
      this.order = ''
      this.order_type = ''
      this.$emit('on-search', this.searchValue)
      this.handelOpChange('search')
    },
    // 取消搜索
    onCancel() {},
    // 点击排序
    handelClickOpItem(item, o, index) {
      this.order = item.key
      this.order_type = o.value
      this.$refs.item.toggle()
      this.handelOpChange()
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.TheHeader {
  width: 100%;
  box-sizing: border-box;
  // padding-bottom: 10px;
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 5;
  ::v-deep {
    .van-search {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 20px;
      // margin-bottom: 10px;
      .van-search__content {
        border-radius: 99px;
        background-color: #f1f1f1;
      }
      .van-cell {
        padding-top: 0;
        padding-bottom: 0;
        font-size: 12px;
      }
    }
    .van-dropdown-menu {
      overflow: hidden;
      flex: 1;
    }
    .van-dropdown-menu__bar {
      height: 38px;
      overflow: hidden;
      box-shadow: none;
    }
    .van-dropdown-menu__title {
      padding: 0 1px;
      font-size: 13px;
      font-weight: 500;
    }
    .van-dropdown-menu__title::after {
      right: -6px;
    }
    .van-dropdown-menu__item {
      max-width: 72px;
      margin: 0 4px;
    }
    .van-dropdown-menu__item:last-of-type .van-dropdown-menu__title::after {
      top: 9999px;
    }
    .van-dropdown-item__option--active .van-cell__value {
      flex: 0.2;
      margin-left: 10px;
    }
  }
  .th-se {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
    background-color: #fff;
    padding-right: 15px;
    position: relative;
    overflow: hidden;
    .se-op {
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      padding: 8px 20px;
      display: flex;
      align-items: center;
      font-weight: 500;
      color: #000000;
      .op-title {
        font-size: 13px;
        margin-right: 16px;
      }
      .op-item {
        margin-right: 8px;
        width: 80px;
        height: 28px;
        background: #f7f7f7;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }
      .op-item-ac {
        border: 2px solid #f04646;
        color: #f04646;
      }
      &:last-of-type {
        margin-bottom: 12px;
      }
    }
    .se-right {
      color: #bbb;
      font-weight: 600;
      position: absolute;
      z-index: 11;
      right: 16px;
      top: 50%;
      font-size: 18px;
      font-weight: 800;
      letter-spacing: -5px;
      transform: translateY(-58%);
      .r-icon-ac {
        color: #f04646;
      }
    }
  }
  .th-reset {
    padding: vw(4) vw(12);
    font-size: vw(12);
    color: #878787;
    margin-top: vw(-5);
    text-align: right;
  }
}
</style>
